var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeavenlyDew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 148.62 131.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Sky);}.cls-2{fill:url(#_1248-4);}.cls-3{fill:url(#_1248-3);}.cls-4{fill:url(#_1248-2);}.cls-5{fill:url(#_1321-3);}.cls-6{fill:url(#_1321-4);}.cls-7{fill:url(#_1321-2);}.cls-8{fill:url(#_1321-6);}.cls-9{fill:url(#_1321-5);}.cls-10{fill:url(#_236-12);}.cls-11{fill:url(#_236-11);}.cls-12{fill:url(#_236-16);}.cls-13{fill:url(#_236-10);}.cls-14{fill:url(#_236-15);}.cls-15{fill:url(#_236-14);}.cls-16{fill:url(#_236-13);}.cls-17{fill:url(#_127-2);}.cls-17,.cls-18,.cls-19{mix-blend-mode:color-dodge;}.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30{opacity:.5;}.cls-18{fill:url(#_127-3);}.cls-31{fill:url(#_236);}.cls-19{fill:url(#_127);}.cls-32{fill:url(#_1321);}.cls-33{fill:url(#_1248);}.cls-34{fill:url(#Sky-9);}.cls-35{fill:url(#Sky-2);}.cls-36{fill:url(#Sky-3);}.cls-37{fill:url(#Sky-4);}.cls-38{fill:url(#Sky-5);}.cls-39{fill:url(#Sky-6);}.cls-40{fill:url(#Sky-7);}.cls-41{fill:url(#Sky-8);}.cls-42{fill:url(#New_Gradient_Swatch_5);}.cls-20{fill:url(#New_Gradient_Swatch_1);}.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30{mix-blend-mode:multiply;}.cls-21{fill:url(#New_Gradient_Swatch_1-10);}.cls-22{fill:url(#New_Gradient_Swatch_1-11);}.cls-23{fill:url(#New_Gradient_Swatch_1-6);}.cls-24{fill:url(#New_Gradient_Swatch_1-9);}.cls-25{fill:url(#New_Gradient_Swatch_1-7);}.cls-26{fill:url(#New_Gradient_Swatch_1-4);}.cls-27{fill:url(#New_Gradient_Swatch_1-3);}.cls-28{fill:url(#New_Gradient_Swatch_1-8);}.cls-29{fill:url(#New_Gradient_Swatch_1-5);}.cls-30{fill:url(#New_Gradient_Swatch_1-2);}.cls-43{isolation:isolate;}.cls-44{fill:url(#Sky-17);}.cls-44,.cls-45{fill-rule:evenodd;}.cls-45{fill:url(#Sky-18);}.cls-46{fill:url(#Sky-15);}.cls-47{fill:url(#Sky-10);}.cls-48{fill:url(#Sky-13);}.cls-49{fill:url(#Sky-12);}.cls-50{fill:url(#Sky-14);}.cls-51{fill:url(#Sky-16);}.cls-52{fill:url(#Sky-11);}.cls-53{fill:url(#_236-9);}.cls-54{fill:url(#_236-7);}.cls-55{fill:url(#_236-6);}.cls-56{fill:url(#_236-5);}.cls-57{fill:url(#_236-4);}.cls-58{fill:url(#_236-8);}.cls-59{fill:url(#_236-3);}.cls-60{fill:url(#_236-2);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_5",
    cx: 70.36,
    cy: 68.22,
    fx: -1.03,
    fy: 6.39,
    r: 110.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f1eff1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#c7c2ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#a198a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#817587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#66576e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#503e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3e2c48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#331e3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2c1736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a1535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky",
    x1: 45.18,
    y1: 38.2,
    x2: 61.42,
    y2: 38.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8e1f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#beddf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#a5d5f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7bc7ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#42b4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#009fdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0077be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#005e9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-2",
    x1: 37.46,
    y1: 38.11,
    x2: 44.25,
    y2: 38.11,
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-3",
    x1: 30.94,
    y1: 63.3,
    x2: 69.42,
    y2: 63.3,
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-4",
    x1: 26.56,
    y1: 56.63,
    x2: 60.62,
    y2: 56.63,
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-5",
    x1: 23.98,
    y1: 64.74,
    x2: 60.62,
    y2: 64.74,
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-6",
    x1: 24.37,
    y1: 75.91,
    x2: 59.41,
    y2: 75.91,
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-7",
    x1: 34.02,
    y1: 87.44,
    x2: 56.42,
    y2: 87.44,
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-8",
    x1: 47.83,
    y1: 92.94,
    x2: 58.28,
    y2: 92.94,
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-9",
    x1: 966.72,
    y1: 38.2,
    x2: 982.96,
    y2: 38.2,
    gradientTransform: "translate(1070.68) rotate(-180) scale(1 -1)",
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-10",
    x1: 959,
    y1: 38.11,
    x2: 965.79,
    y2: 38.11,
    gradientTransform: "translate(1070.68) rotate(-180) scale(1 -1)",
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-11",
    x1: 952.48,
    y1: 63.3,
    x2: 990.96,
    y2: 63.3,
    gradientTransform: "translate(1070.68) rotate(-180) scale(1 -1)",
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-12",
    x1: 948.1,
    y1: 56.63,
    x2: 982.16,
    y2: 56.63,
    gradientTransform: "translate(1070.68) rotate(-180) scale(1 -1)",
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-13",
    x1: 945.52,
    y1: 64.74,
    x2: 982.16,
    y2: 64.74,
    gradientTransform: "translate(1070.68) rotate(-180) scale(1 -1)",
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-14",
    x1: 946.08,
    y1: 75.89,
    x2: 980.95,
    y2: 75.89,
    gradientTransform: "translate(1070.68) rotate(-180) scale(1 -1)",
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-15",
    x1: 955.56,
    y1: 87.44,
    x2: 977.96,
    y2: 87.44,
    gradientTransform: "translate(1070.68) rotate(-180) scale(1 -1)",
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-16",
    x1: 969.37,
    y1: 92.94,
    x2: 979.82,
    y2: 92.94,
    gradientTransform: "translate(1070.68) rotate(-180) scale(1 -1)",
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-17",
    x1: 74.58,
    y1: 108.87,
    x2: 74.59,
    y2: 80.95,
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky-18",
    x1: 74.58,
    y1: 48.52,
    x2: 74.58,
    y2: 31.86,
    xlinkHref: "#Sky"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236",
    x1: 74.31,
    y1: 0,
    x2: 74.31,
    y2: 131.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9e0ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98aad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 74.31,
    y1: 83.91,
    x2: 74.31,
    y2: 131.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7cba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a5ba4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-2",
    x1: 74.31,
    y1: 129.92,
    x2: 74.31,
    y2: 1.93,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127",
    x1: 74.31,
    y1: -3960.5,
    x2: 74.31,
    y2: -3912.56,
    gradientTransform: "translate(0 -3912.56) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7cba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#acbcdd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    x1: 23.79,
    y1: 64.8,
    x2: 23.79,
    y2: 86.3,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321",
    x1: -5329.58,
    y1: 1215.48,
    x2: -5329.58,
    y2: 1195.49,
    gradientTransform: "translate(-1430.52 5291.41) rotate(118.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85769c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98aad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9e0ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-3",
    x1: -5327.13,
    y1: 1193.65,
    x2: -5327.13,
    y2: 1211.38,
    gradientTransform: "translate(-1430.52 5291.41) rotate(118.16)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-4",
    x1: -5343.34,
    y1: 1198.17,
    x2: -5343.34,
    y2: 1204.52,
    gradientTransform: "translate(-1430.52 5291.41) rotate(118.16)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127-2",
    x1: -5348.75,
    y1: 1206.7,
    x2: -5348.75,
    y2: 1201.45,
    gradientTransform: "translate(-1430.52 5291.41) rotate(118.16)",
    xlinkHref: "#_127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248",
    x1: -5344.44,
    y1: 1186.78,
    x2: -5344.44,
    y2: 1193.32,
    gradientTransform: "translate(-1430.52 5291.41) rotate(118.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a5ba4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1f3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-3",
    x1: -5313.9,
    y1: 1201.45,
    x2: -5313.9,
    y2: 1199.91,
    gradientTransform: "translate(-1430.52 5291.41) rotate(118.16)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-5",
    x1: 4.83,
    y1: 57.22,
    x2: 0.44,
    y2: 65.9,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-2",
    x1: -9720.92,
    y1: 3565.79,
    x2: -9720.92,
    y2: 3545.8,
    gradientTransform: "translate(-1430.52 -10140.51) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-6",
    x1: -9718.46,
    y1: 3543.96,
    x2: -9718.46,
    y2: 3561.69,
    gradientTransform: "translate(-1430.52 -10140.51) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-7",
    x1: -9734.68,
    y1: 3548.34,
    x2: -9734.68,
    y2: 3554.87,
    gradientTransform: "translate(-1430.52 -10140.51) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-8",
    x1: -9740.09,
    y1: 3557.01,
    x2: -9740.09,
    y2: 3551.76,
    gradientTransform: "translate(-1430.52 -10140.51) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-2",
    x1: -9735.39,
    y1: 3537.56,
    x2: -9735.39,
    y2: 3543.97,
    gradientTransform: "translate(-1430.52 -10140.51) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-4",
    x1: -9705.23,
    y1: 3551.76,
    x2: -9705.23,
    y2: 3550.23,
    gradientTransform: "translate(-1430.52 -10140.51) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-9",
    x1: -0.18,
    y1: 81.87,
    x2: 5.98,
    y2: 77.39,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-3",
    x1: 19.46,
    y1: 71.54,
    x2: 3.04,
    y2: 59.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-5",
    x1: 10.82,
    y1: 58.22,
    x2: 10.82,
    y2: 72.25,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-6",
    x1: 10.82,
    y1: 21.03,
    x2: 10.82,
    y2: 35.06,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-7",
    x1: -3789.03,
    y1: 64.8,
    x2: -3789.03,
    y2: 86.3,
    gradientTransform: "translate(-3664.2) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-4",
    x1: -3530.46,
    y1: 4576.96,
    x2: -3530.46,
    y2: 4556.97,
    gradientTransform: "translate(-2233.68 5291.41) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-10",
    x1: -3528.01,
    y1: 4555.13,
    x2: -3528.01,
    y2: 4572.86,
    gradientTransform: "translate(-2233.68 5291.41) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-11",
    x1: -3544.23,
    y1: 4559.65,
    x2: -3544.23,
    y2: 4566,
    gradientTransform: "translate(-2233.68 5291.41) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127-3",
    x1: -3549.63,
    y1: 4568.18,
    x2: -3549.63,
    y2: 4562.93,
    gradientTransform: "translate(-2233.68 5291.41) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-3",
    x1: 95.21,
    y1: 18.66,
    x2: 118.73,
    y2: 12.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-8",
    x1: -3514.78,
    y1: 4562.93,
    x2: -3514.78,
    y2: 4561.39,
    gradientTransform: "translate(-2233.68 5291.41) rotate(61.84) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-12",
    x1: -3807.99,
    y1: 57.22,
    x2: -3812.38,
    y2: 65.9,
    gradientTransform: "translate(-3664.2) rotate(-180) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-5",
    x1: -7921.8,
    y1: 6927.27,
    x2: -7921.8,
    y2: 6907.28,
    gradientTransform: "translate(-2233.68 -10140.51) rotate(-61.84)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-13",
    x1: -7919.35,
    y1: 6905.44,
    x2: -7919.35,
    y2: 6923.17,
    gradientTransform: "translate(-2233.68 -10140.51) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-14",
    x1: -7935.56,
    y1: 6909.82,
    x2: -7935.56,
    y2: 6916.35,
    gradientTransform: "translate(-2233.68 -10140.51) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-15",
    x1: -7940.97,
    y1: 6918.5,
    x2: -7940.97,
    y2: 6913.24,
    gradientTransform: "translate(-2233.68 -10140.51) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-4",
    x1: -7936.27,
    y1: 6899.04,
    x2: -7936.27,
    y2: 6905.45,
    gradientTransform: "translate(-2233.68 -10140.51) rotate(-61.84)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-9",
    x1: -7906.12,
    y1: 6913.24,
    x2: -7906.12,
    y2: 6911.71,
    gradientTransform: "translate(-2233.68 -10140.51) rotate(-61.84)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-16",
    x1: -3813,
    y1: 81.87,
    x2: -3806.84,
    y2: 77.39,
    gradientTransform: "translate(-3664.2) rotate(-180) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-6",
    x1: -3793.36,
    y1: 71.54,
    x2: -3809.78,
    y2: 59.97,
    gradientTransform: "translate(-3664.2) rotate(-180) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-10",
    x1: -3802,
    y1: 58.22,
    x2: -3802,
    y2: 72.25,
    gradientTransform: "translate(-3664.2) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-11",
    x1: -3802,
    y1: 21.03,
    x2: -3802,
    y2: 35.06,
    gradientTransform: "translate(-3664.2) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 74.31,
    cy: 65.93,
    r: 63.55
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.42,19.99s-20.49,13.95-6.79,36.42c0,0-12.96-8.15-8.52-23.21,0,0,2.22-9.13,15.31-13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.79,26.21s-6.17,12.38.45,23.81c0,0-14.96-11.32-.45-23.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m31.52,33.45s0,14.18,16.67,22.96c16.67,8.78,19.44,17.59,19.44,17.59,0,0,5.1,10.74-1.95,17.31-1.5,1.4-3.57,2.09-5.6,1.75-1.6-.27-3.12-1.08-2.85-3.27.59-4.73,7.16-2.04,7.16-2.04,0,0,3.21-4.04-.28-11.78-3.85-8.54-18.94-15.78-18.94-15.78,0,0-17.63-9.13-13.66-26.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m26.89,39.03s1.25,13.85,15.41,23.54c13.59,9.3,18.32,11.4,18.32,11.4,0,0-6.45,2.35-19.77-7.33-13.32-9.68-15.24-21.21-13.96-27.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m60.62,77.46s-25.12-.25-36.65-26.69c0,0,0,13.91,11.39,21.88,11.39,7.97,21.77,6.29,25.26,4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m24.54,67.17s13.88,20.14,34.87,14.09c0,0-21.59,13.61-35.04-13.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m56.42,86.14s-9.23,4.08-22.4-1.65c0,0,15.32,12.1,22.4,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m55.71,91.01s.93,2.51,2.58,3.08c0,0-7.45,2.29-10.45-.93,0,0,6.08.07,7.87-2.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m87.72,19.99s20.49,13.95,6.79,36.42c0,0,12.96-8.15,8.52-23.21,0,0-2.22-9.13-15.31-13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m105.35,26.21s6.17,12.38-.45,23.81c0,0,14.96-11.32.45-23.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m117.62,33.45s0,14.18-16.67,22.96c-16.67,8.78-19.44,17.59-19.44,17.59,0,0-5.1,10.74,1.95,17.31,1.5,1.4,3.57,2.09,5.6,1.75,1.6-.27,3.12-1.08,2.85-3.27-.59-4.73-7.16-2.04-7.16-2.04,0,0-3.21-4.04.28-11.78,3.85-8.54,18.94-15.78,18.94-15.78,0,0,17.63-9.13,13.66-26.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m122.25,39.03s-1.3,13.55-15.41,23.16c-13.61,9.26-18.32,11.78-18.32,11.78,0,0,6.45,2.35,19.77-7.33s15.24-21.21,13.96-27.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m88.52,77.46s25.12-.25,36.65-26.69c0,0,0,13.91-11.39,21.88-11.39,7.97-21.77,6.29-25.26,4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m124.6,67.17s-13.88,20.14-34.87,14.09c0,0,21.95,13.61,34.87-14.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m92.72,86.14s9.23,4.08,22.4-1.65c0,0-15.32,12.1-22.4,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m93.43,91.01s-.93,2.51-2.58,3.08c0,0,7.45,2.29,10.45-.93,0,0-6.08.07-7.87-2.15Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m62.6,110.62c.82,3.04,5.28,1.54,4-1.1-3.14-6.48,2.32-15.69,4.93-21.78-3.68,6.35-10.99,15.39-8.93,22.89m5.57,2.91c-.66-.61-1.74-.61-2.4,0s-.66,1.59,0,2.2c.66.61,1.74.61,2.4,0,.66-.61.66-1.59,0-2.2Zm6.41,7.09c7.71,0,13.96-5.72,13.96-12.78,0-10.21-12.4-20.89-13.96-31.95-1.56,11.06-13.96,21.74-13.96,31.95,0,7.06,6.25,12.78,13.96,12.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m67.43,49.56c.49,1.82,3.15.92,2.39-.66-1.87-3.87,1.39-9.36,2.94-13-2.2,3.79-6.56,9.19-5.33,13.66m3.32,1.74c-.4-.36-1.04-.36-1.43,0s-.4.95,0,1.31c.4.36,1.04.36,1.43,0,.4-.36.4-.95,0-1.31Zm3.83,4.23c4.6,0,8.33-3.41,8.33-7.63,0-6.09-7.4-12.47-8.33-19.07-.93,6.6-8.33,12.97-8.33,19.07,0,4.21,3.73,7.63,8.33,7.63Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m74.32,0C37.9,0,8.39,29.52,8.39,65.93s29.52,65.93,65.93,65.93,65.93-29.52,65.93-65.93S110.73,0,74.32,0Zm0,128.16c-16.62,0-32.25-6.47-44-18.23-11.76-11.76-18.23-27.38-18.23-44.01s6.47-32.25,18.23-44C42.06,10.17,57.69,3.69,74.32,3.69s32.25,6.47,44,18.23c11.76,11.76,18.23,27.38,18.23,44s-6.47,32.25-18.23,44.01c-11.75,11.75-27.38,18.23-44,18.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m74.32,130.05c-29.77,0-54.97-19.4-63.44-46.14,7.83,27.67,33.27,47.94,63.44,47.94s55.61-20.27,63.44-47.94c-8.48,26.74-33.67,46.14-63.44,46.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m119.57,20.67C107.48,8.58,91.41,1.93,74.32,1.93s-33.16,6.66-45.25,18.75c-12.09,12.09-18.74,28.16-18.74,45.25s6.66,33.16,18.74,45.25c12.09,12.09,28.16,18.74,45.25,18.74s33.17-6.66,45.25-18.74c12.09-12.09,18.74-28.16,18.74-45.25s-6.66-33.17-18.74-45.25Zm-1.25,89.26c-11.75,11.75-27.38,18.23-44,18.23s-32.25-6.47-44-18.23c-11.76-11.76-18.23-27.38-18.23-44.01s6.47-32.25,18.23-44C42.06,10.17,57.69,3.69,74.32,3.69s32.25,6.47,44,18.23c11.76,11.76,18.23,27.38,18.23,44s-6.47,32.25-18.23,44.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m137.76,47.94C129.93,20.27,104.49,0,74.32,0S18.7,20.27,10.87,47.94C19.35,21.2,44.55,1.99,74.32,1.99s54.97,19.21,63.44,45.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m21.11,98.93l1.72,5.03s.43,1.37-.28,2.8l3.93,4.53-.52-6.18-4.85-6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.96,18.03c-2.91,9.79-7.21,17.51-7.21,17.51-.98,2.17-2.33,5.08-2.33,5.08-.57,1.24-1.56,3.84-1.56,3.84,2.82-3.12,4.66-5.85,6.82-8.67,4.17-5.45,7.01-15.06,8.4-20.66.65-2.63.99-4.37.99-4.37,2.42-1.17,3.7-1.9,3.85-1.98.22-.11.45-.21.67-.31-.99-1.3-2.2-2.27-2.2-2.27-3.74-.56-5.28,1.48-5.28,1.48-.23,1.88-.54,3.7-.91,5.44-.37,1.72-.79,3.36-1.26,4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m17.43,40.62s2.11-4.66,2.25-4.9c0,0,4.38-7.9,7.29-17.69.46-1.56.89-3.2,1.26-4.91,0,0,.75,13.06-10.79,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m31.39,15.89s-.45.46-1.8,4.68c0,0,.46-5.89,1.99-10.6,0,0,1.6-2.99,2.85-3.75.19.16,1.72,1.19,3.97,4.41-.22.1-.91.64-1.13.75-.15.09-2.43,1.73-5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m29.13,7.68s1.33-1.77,4.52-1.57c-1.36,1.86-3.95,2.3-4.52,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m31.39,15.89l.97-2.77c1.29-1.73,2.77-2.63,2.77-2.63,0,0,1.31.19,2.57.62l-.42.28c-3.05,2.01-5.88,4.51-5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m18.15,41.78s.83-2.07,1.43-3.99l.85-3.5c-.12.15-.52,1.06-.67,1.24-1.61,3.22-2.54,5.26-3.89,8.92,0,0,1.64-1.96,2.28-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m10.32,50.03s-4.56,4.81-7.29,15.9H0s.72-12.21,12.37-22.62l-2.05,6.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m26.96,113.82c-2.91-9.79-7.21-17.51-7.21-17.51-.98-2.17-2.33-5.08-2.33-5.08-.57-1.24-1.56-3.84-1.56-3.84,2.82,3.12,4.66,5.85,6.82,8.67,4.17,5.45,7.01,15.06,8.4,20.66.65,2.63.99,4.37.99,4.37,2.42,1.17,3.7,1.9,3.85,1.98.22.11.45.21.67.31-.99,1.3-2.2,2.27-2.2,2.27-3.74.56-5.28-1.48-5.28-1.48-.23-1.88-.54-3.7-.91-5.44-.37-1.72-.79-3.36-1.26-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m17.43,91.24s2.11,4.66,2.25,4.9c0,0,4.38,7.9,7.29,17.69.46,1.56.89,3.2,1.26,4.91,0,0,.75-13.06-10.79-27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m31.05,115.61s-.11-.11-1.46-4.33c0,0,.46,5.89,1.99,10.6,0,0,1.6,2.99,2.85,3.75.19-.16,3.4-3.02,4.3-4.2-.22-.1-1.69-1.17-1.91-1.28-.15-.09-2.9-1.86-5.77-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m29.13,124.17s1.33,1.77,4.52,1.57c-1.36-1.86-3.95-2.3-4.52-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m31.05,115.61l.82,2.29c.61,2.08,2.11,3.67,2.11,3.67,0,0,1.06.22,2.01-.28l1.2-.89c-.61-.33-4.12-3.04-6.15-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m18.15,90.07s.83,2.07,1.43,3.99l.85,3.5c-.12-.15-.52-1.06-.67-1.24-1.61-3.22-2.54-5.26-3.89-8.92,0,0,1.64,1.96,2.28,2.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m10.32,81.82s-4.56-4.81-7.29-15.9H0s.72,12.21,12.37,22.62l-2.05-6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m3.03,65.93c2.59-10.81,7.29-15.9,7.29-15.9l1.17-3.85C2.86,54.36,1.46,65.93,1.46,65.93c0,0,1.4,11.57,10.03,19.74l-1.17-3.85s-4.7-5.09-7.29-15.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m9.27,80.49s.36,2.19.3,3.18l.74,2.91,2.05,1.97-.88-2.88-1.17-3.85-1.05-1.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "12.37 43.3 11.49 46.18 10.32 50.03 9.27 51.36 9.27 48.53 11.49 44.11 12.37 43.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m127.52,98.93l-1.72,5.03s-.43,1.37.28,2.8l-3.93,4.53.52-6.18,4.85-6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m121.66,18.03c2.91,9.79,7.21,17.51,7.21,17.51.98,2.17,2.33,5.08,2.33,5.08.57,1.24,1.56,3.84,1.56,3.84-2.82-3.12-4.66-5.85-6.82-8.67-4.17-5.45-7.01-15.06-8.4-20.66-.65-2.63-.99-4.37-.99-4.37-2.42-1.17-3.7-1.9-3.85-1.98-.22-.11-.45-.21-.67-.31.99-1.3,2.2-2.27,2.2-2.27,3.74-.56,5.28,1.48,5.28,1.48.23,1.88.54,3.7.91,5.44.37,1.72.79,3.36,1.26,4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m131.2,40.62s-2.11-4.66-2.25-4.9c0,0-4.38-7.9-7.29-17.69-.46-1.56-.89-3.2-1.26-4.91,0,0-.75,13.06,10.79,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m117.24,15.89s.45.46,1.8,4.68c0,0-.46-5.89-1.99-10.6,0,0-1.6-2.99-2.85-3.75-.19.16-1.72,1.19-3.97,4.41.22.1.91.64,1.13.75.15.09,2.43,1.73,5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m119.5,7.68s-1.33-1.77-4.52-1.57c1.36,1.86,3.95,2.3,4.52,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m117.24,15.89l-.97-2.77c-1.29-1.73-2.77-2.63-2.77-2.63,0,0-1.31.19-2.57.62l.42.28c3.05,2.01,5.88,4.51,5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m130.48,41.78s-.83-2.07-1.43-3.99l-.85-3.5c.12.15.52,1.06.67,1.24,1.61,3.22,2.54,5.26,3.89,8.92,0,0-1.64-1.96-2.28-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m138.31,50.03s4.56,4.81,7.29,15.9h3.03s-.72-12.21-12.37-22.62l2.05,6.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m121.66,113.82c2.91-9.79,7.21-17.51,7.21-17.51.98-2.17,2.33-5.08,2.33-5.08.57-1.24,1.56-3.84,1.56-3.84-2.82,3.12-4.66,5.85-6.82,8.67-4.17,5.45-7.01,15.06-8.4,20.66-.65,2.63-.99,4.37-.99,4.37-2.42,1.17-3.7,1.9-3.85,1.98-.22.11-.45.21-.67.31.99,1.3,2.2,2.27,2.2,2.27,3.74.56,5.28-1.48,5.28-1.48.23-1.88.54-3.7.91-5.44.37-1.72.79-3.36,1.26-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m131.2,91.24s-2.11,4.66-2.25,4.9c0,0-4.38,7.9-7.29,17.69-.46,1.56-.89,3.2-1.26,4.91,0,0-.75-13.06,10.79-27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m117.58,115.61s.11-.11,1.46-4.33c0,0-.46,5.89-1.99,10.6,0,0-1.6,2.99-2.85,3.75-.19-.16-3.4-3.02-4.3-4.2.22-.1,1.69-1.17,1.91-1.28.15-.09,2.9-1.86,5.77-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m119.5,124.17s-1.33,1.77-4.52,1.57c1.36-1.86,3.95-2.3,4.52-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m117.58,115.61l-.82,2.29c-.61,2.08-2.11,3.67-2.11,3.67,0,0-1.06.22-2.01-.28l-1.2-.89c.61-.33,4.12-3.04,6.15-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m130.48,90.07s-.83,2.07-1.43,3.99l-.85,3.5c.12-.15.52-1.06.67-1.24,1.61-3.22,2.54-5.26,3.89-8.92,0,0-1.64,1.96-2.28,2.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m138.31,81.82s4.56-4.81,7.29-15.9h3.03s-.72,12.21-12.37,22.62l2.05-6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m145.6,65.93c-2.59-10.81-7.29-15.9-7.29-15.9l-1.17-3.85c8.63,8.18,10.03,19.74,10.03,19.74,0,0-1.4,11.57-10.03,19.74l1.17-3.85s4.7-5.09,7.29-15.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m139.35,80.49s-.36,2.19-.3,3.18l-.74,2.91-2.05,1.97.88-2.88,1.17-3.85,1.04-1.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "136.25 43.3 137.13 46.18 138.31 50.03 139.35 51.36 139.35 48.53 137.13 44.11 136.25 43.3"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeavenlyDew);
export default __webpack_public_path__ + "static/media/heavenly-dew.5db0eff42e43ba262fd5e6a3ca862bbd.svg";
export { ForwardRef as ReactComponent };